import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/Icon';
import Button from 'widgets/Button';
import './ModalContent.scss';

const RetryLogin = ({
  onClick, rootStyleButton, labelStyleButton, description, buttonLabel
}) => (
  <React.Fragment>
    <div className="Modal__Content__Text" style={{ paddingBottom: '36px' }}>
      <FormattedMessage id={description} />
    </div>
    <Icon
      name="email-error"
    />
    <div className="Modal__Content__Action">
      <Button
        id="authAction"
        cssStyles={{
          root: rootStyleButton,
          label: labelStyleButton,
        }}
        onClick={onClick}
      >
        <FormattedMessage id={buttonLabel} />
      </Button>
    </div>
  </React.Fragment>
);

export default RetryLogin;

RetryLogin.propTypes = {
  rootStyleButton: PropTypes.object.isRequired,
  labelStyleButton: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  description: PropTypes.string,
  buttonLabel: PropTypes.string
};

RetryLogin.defaultProps = {
  description: 'retryLogin.modal.content.text',
  buttonLabel: 'retryLogin.modal.content.action.buttonLabel'
};



// WEBPACK FOOTER //
// ./src/components/ModalContent/RetryLogin.jsx